import React, { useContext } from "react";
import { Modal } from "antd";
import TextEditor from "../../pages/TextEditor";
import { context } from "../../context/context";
const TextEditorModal = () => {
  const {
    setLinkAddress,
    textEditorShow,
    setTextEditorShow,
    setTextEditorHTML,
  } = useContext(context);

  const handleOk = () => {
    setTextEditorShow(false);
  };
  const handleCancel = () => {
    setTextEditorShow(false);
    // setLinkAddress("");

  };
  return (
    <>
      <Modal
        style={{ height: 200 }}
        width={"1100px"}
        open={textEditorShow}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <TextEditor />
      </Modal>
    </>
  );
};

export default TextEditorModal;
